import { useAuthentication } from '../contexts/AuthenticationProvider';

export const useAuthz = () => {
  const { isLoading, user } = useAuthentication();

  const isAuthorized = (permissionsGroups: string[]): boolean => {
    if (isLoading) {
      return false;
    }

    if (!user || !user.permissions) {
      return false;
    }

    return user.permissions.some((permission) =>
      permissionsGroups.includes(permission),
    );
  };

  return {
    isAuthorized,
  };
};
